import loadable from '@loadable/component';

import { createPlugin } from '@backstage/core-plugin-api';

import { createWorkflowExtension } from '@spotify/plugin-confidence-workflows-react';

import { RolloutTableRow } from './components';
import { RolloutIcon } from './components/RolloutIcon';
import {
  FLAG_VARIANT_CHANGE_EXTENSION,
  REACH_CHANGE_EXTENSION,
  ROLLOUT_DESCRIPTION_CHANGE_EXTENSION,
  ROLLOUT_FLAG_CHANGE_EXTENSION,
  SCHEDULE_CHANGE_EXTENSION,
} from './components/RolloutInstanceUpdates';
import { ROLLOUT_WORKFLOW_ID } from './constants';

export const confidenceWorkflowsModuleRolloutPlugin = createPlugin({
  id: 'confidence-workflows-module-rollout',
});

const componentsChunk = () =>
  import(
    /* webpackChunkName: "workflows-rollout-pages", webpackPrefetch: 5 */ './components'
  );
const loadOptions = {};

const RolloutWorkflowPage = loadable(
  () => componentsChunk().then(m => m.RolloutWorkflowPage),
  loadOptions,
);
const RolloutWorkflowInstancePage = loadable(
  () => componentsChunk().then(m => m.RolloutWorkflowInstancePage),
  loadOptions,
);
const CreateRollout = loadable(
  () => componentsChunk().then(m => m.CreateRollout),
  loadOptions,
);

export const RolloutWorkflowExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(
    createWorkflowExtension({
      title: 'Rollout',
      workflowId: ROLLOUT_WORKFLOW_ID,
      workflowPage: () => <RolloutWorkflowPage />,
      workflowInstancePage: () => <RolloutWorkflowInstancePage />,
      workflowTableRowComponent: RolloutTableRow,
      workflowIcon: RolloutIcon,
      createComponent: overrides => <CreateRollout overrides={overrides} />,
    }),
  );

// Change extensions
export const FlagVariantChangeExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(FLAG_VARIANT_CHANGE_EXTENSION);

export const ReachChangeExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(REACH_CHANGE_EXTENSION);

export const RolloutDescriptionChangeExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(
    ROLLOUT_DESCRIPTION_CHANGE_EXTENSION,
  );

export const RolloutFlagChangeExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(ROLLOUT_FLAG_CHANGE_EXTENSION);

export const ScheduleChangeExtension =
  confidenceWorkflowsModuleRolloutPlugin.provide(SCHEDULE_CHANGE_EXTENSION);
